import { Controller } from "@hotwired/stimulus"

// Dropdown color picker with native <input type="color">,
// hex text input, and preset color circles.
//
// Replicates WebsiteColorBtn.tsx (@reach/menu-button + @uiw/react-color-sketch).
export default class extends Controller {
  static targets = ["trigger", "panel", "colorInput", "hexInput"]

  #onClick = null

  connect() {
    this.#onClick = this.#handleOutsideClick.bind(this)
  }

  disconnect() {
    document.removeEventListener("click", this.#onClick)
  }

  toggle(event) {
    event.stopPropagation()
    const isOpen = !this.panelTarget.classList.contains("hidden")

    if (isOpen) {
      this.#close()
    } else {
      this.#open()
    }
  }

  onColorChange() {
    const color = this.colorInputTarget.value
    this.hexInputTarget.value = color.toUpperCase()
    this.triggerTarget.style.backgroundColor = color
  }

  onHexChange() {
    let hex = this.hexInputTarget.value.trim()
    if (!hex.startsWith("#")) hex = "#" + hex

    // Validate hex
    if (/^#[0-9A-Fa-f]{6}$/.test(hex)) {
      this.colorInputTarget.value = hex
      this.triggerTarget.style.backgroundColor = hex
      this.hexInputTarget.value = hex.toUpperCase()

      // Dispatch input event so manage--appearance picks it up
      this.colorInputTarget.dispatchEvent(new Event("input", { bubbles: true }))
    }
  }

  pickPreset(event) {
    const color = event.currentTarget.dataset.color
    this.colorInputTarget.value = color
    this.hexInputTarget.value = color.toUpperCase()
    this.triggerTarget.style.backgroundColor = color
  }

  // Private

  #open() {
    this.panelTarget.classList.remove("hidden")
    document.addEventListener("click", this.#onClick)
  }

  #close() {
    this.panelTarget.classList.add("hidden")
    document.removeEventListener("click", this.#onClick)
  }

  #handleOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.#close()
    }
  }
}
